module.exports = "/_next/static/images/Frame-ab8e54c96dd641056a4981236c1a8768.svg";